import { render, staticRenderFns } from "./PropertyDialog.vue?vue&type=template&id=2115cd52&scoped=true"
import script from "./PropertyDialog.vue?vue&type=script&lang=js"
export * from "./PropertyDialog.vue?vue&type=script&lang=js"
import style0 from "./PropertyDialog.vue?vue&type=style&index=0&id=2115cd52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2115cd52",
  null
  
)

export default component.exports